import { CSSProperties, useEffect, useRef, useState } from "react";
// import {
//   FileIcon,
//   MenuIcon,
//   MoveToIcon,
//   RightArrowIcon,
//   TicketIcon,
// } from "pages/support-tickets/icons";
import { message, Modal, Popover, Select, Spin, Tooltip } from "antd";
import { priorityColorObj, ticketStatusConversion } from "./constants";
import { priorityArr } from "../constants";
import styles from "./styles.module.scss";
import { getInitialLetters } from "utils/constants";
import {
  AccidentDate,
  Car,
  CaseOpenDate,
  EyeIcon,
  NotesIcon,
  SearchIcon,
  StatusHistoryIcon,
  UploadFilesRed,
  ViewDetailsIcon,
} from "icons";
import { useNavigate } from "react-router-dom";
import { getFormattedDate, timeTillNow } from "utils/helpers";
import { ConditionalRenderer } from "components";
import { UseLazyApiCallV2 } from "hooks";
import { useCurrentUserContext } from "providers";
import { admin } from "authRoute/constants";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { ReminderHistoryTable } from "../../status-history-table";
import { CaseStatusHistory } from "./components/ticket-history";
import { CaseStatusHistoryModal } from "./components/case-status-history";
import { UpdateCaseUser } from "./components/update-case-user";

export function CaseCard({
  ticketData,
  handleUpdateStatus,
  handleOpenModal,
  setTicketData,
  employees,
  refetchCases,
}) {
  const { translator } = useLanguageTranslator();
  const { user } = useCurrentUserContext();
  const [openEmployeesDropdown, setOpenEmployeesDropdown] = useState(false);
  const [caseStatusHistory, setCaseStatusHistory] = useState({
    id: null,
    isOpenModal: false,
  });
  const dropdownRef = useRef(null);
  const [
    updateCaseUser,
    {
      data: updateCaseUserData,
      isLoading: updateCaseUserLoading,
      error: updateCaseUserErr,
    },
  ] = UseLazyApiCallV2({
    url: "/update_case_user",
    method: "POST",
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenEmployeesDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const navigate = useNavigate();
  function handleClickViewDetail() {
    navigate(`/cases/${ticketData?.caseId}`, { state: { employees } });
  }
  function handleClickViewFiles() {
    navigate(`/cases/${ticketData?.caseId}`, {
      state: {
        origin: "upload",
        employees,
      },
    });
  }
  function handleClickViewNotes() {
    navigate(`/cases/${ticketData?.caseId}`, {
      state: {
        origin: "notes",
        employees,
      },
    });
  }

  function handleClickStatusHistory(id) {
    setCaseStatusHistory({
      id,
      isOpenModal: true,
    });
  }
  function closeCaseHistoryModal() {
    setCaseStatusHistory({
      ...caseStatusHistory,
      isOpenModal: false,
    });
  }

  const actionBtns = [
    {
      key: "viewStatusHistory",
      icon: StatusHistoryIcon,
      clickHandler: handleClickStatusHistory,
    },
    {
      key: "viewDetails",
      icon: EyeIcon,
      clickHandler: handleClickViewDetail,
    },
    // {
    //   key: "viewFiles",
    //   icon: UploadFilesRed,
    //   clickHandler: handleClickViewFiles,
    // },
    // {
    //   key: "viewNotes",
    //   icon: NotesIcon,
    //   clickHandler: handleClickViewNotes,
    // },
  ];

  function handleTicketClick(e) {
    e.stopPropagation();

    const children = Array.from(e.target?.children);

    const btnClass =
      (children?.length && Array.from(children[0]?.classList)?.[0]) || null;

    const classListCheck =
      (children?.length &&
        Array.from(children[0]?.classList)?.includes(
          "ant-popover-inner-content",
        )) ||
      (btnClass && btnClass?.includes("popoverBtn"));

    const tagsArr = ["BUTTON", "svg", "circle", "path", "SPAN"];
    if (tagsArr.includes(e.target?.tagName) || classListCheck) return;

    setTicketData(ticketData);
    handleOpenModal();
  }

  async function handleSelect(value, data, case_id) {
    try {
      const res = await updateCaseUser({
        params: { case_id, newUser: value, loggedUser: user?.email },
      });
      if (res?.status === "SUCCESS") {
        message.success(res?.message);
        refetchCases();
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setOpenEmployeesDropdown(false);
    }
  }

  function handleClickAssignee(e) {
    if (!admin?.includes(user?.role)) return;
    e.stopPropagation();
    setOpenEmployeesDropdown((prev) => !prev);
  }
  return (
    <div
      className={styles.ticket}
      onClick={handleTicketClick}
      ref={dropdownRef}
    >
      <div className={styles.nameAndCase}>
        <div className={styles.nameAndSmileNum}>
          <div className={styles.name}>{ticketData?.nameOfPolicyholder}</div>
          <div className={styles.smileNum}>
            Kunden-Nr: {ticketData?.customerNoSmile}
          </div>
          <div className={styles.caseNum}>
            <span>{translator("casesTable.tableColumnsLabel.caseId")}: </span>
            {ticketData?.caseId}
          </div>
        </div>
        {/* "caseOpenDate": "Fall-Eröffnungsdatum",
      "accidentDate": "Unfalldatum",
      "car": "Auto",
      "assignee": "Zessionar" */}
        <div className={styles.initialsAndDetails}>
          <Spin spinning={updateCaseUserLoading}>
            <Tooltip
              title={`${translator("casesTable.tableColumnsLabel.assignee")}: ${
                ticketData?.createdByName
              }`}
            >
              <div className={styles.initials} onClick={handleClickAssignee}>
                {getInitialLetters(ticketData?.createdByName)}
              </div>
            </Tooltip>
          </Spin>
          <UpdateCaseUser
            caseId={ticketData?.caseId}
            employees={employees}
            openEmployeesDropdown={openEmployeesDropdown}
            refetchCases={refetchCases}
            setOpenEmployeesDropdown={setOpenEmployeesDropdown}
          />
        </div>
      </div>
      <div className={styles.openDate}>
        <div className={styles.label}>
          <CaseOpenDate />{" "}
          {translator("casesTable.tableColumnsLabel.caseOpenDate")}:
        </div>
        <div className={styles.value}>
          {getFormattedDate(ticketData?.lastUpdated || ticketData?.createdAt)}
        </div>
      </div>
      <div className={styles.accidentDate}>
        <div className={styles.label}>
          <AccidentDate />{" "}
          {translator("casesTable.tableColumnsLabel.accidentDate")}:
        </div>
        <div className={styles.value}>{ticketData?.dayOfAccident}</div>
      </div>
      <div className={styles.car}>
        <div className={styles.label}>
          <Car /> {translator("casesTable.tableColumnsLabel.car")}:
        </div>
        <ConditionalRenderer condition={ticketData?.carModel}>
          <div className={styles.value}>{ticketData?.carModel}</div>
        </ConditionalRenderer>
      </div>
      <div className={styles.lastUpdated}>
        <div className={styles.label}>
          {translator("casesTable.tableColumnsLabel.lastUpdated")}:{" "}
          <span>{timeTillNow(ticketData?.lastUpdated)}</span>
        </div>
        <div className={styles.icons}>
          {actionBtns.map((actionBtn) => (
            <Tooltip
              title={translator(`casesTable.${actionBtn?.key}`)}
              key={actionBtn?.key}
            >
              <div
                className={styles.actionBtnIcon}
                onClick={() => actionBtn.clickHandler(ticketData?.caseId)}
                key={actionBtn.key}
              >
                {<actionBtn.icon />}
              </div>
            </Tooltip>
          ))}
        </div>
      </div>
      <CaseStatusHistoryModal
        caseStatusHistory={caseStatusHistory}
        closeCaseHistoryModal={closeCaseHistoryModal}
      />
    </div>
  );
}
